// extracted by mini-css-extract-plugin
export default {"languages-icon":"languages-icon-vbLG0so","language-button":"language-button-Ul2RHQp"};